import  { useState, useEffect } from 'react';
import { ManText, ManSelect, ManSelectItem,ManInputText} from "@craft-design-system/core-components-react";
import Shimmer from "./Shimmer";
import useDropdownData from '../utils/dropdown_data_loading/useDropdownData';
import useHandleQuery from "../utils/dropdown_data_loading/useHandleQuery";
import useDynamicFiltering from '../utils/dropdown_data_loading/useDynamicFiltering';
import { Collapse } from 'reactstrap'; // or react-bootstrap
import filters from '../assets/images/filters.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import MAN_Update from'../assets/images/MAN_Update.svg';
import reload from '../assets/images/reload.png';
// import filter from '../assets/images/filter.jpg';
import submit from '../assets/images/submit.png';
import filter from '../assets/images/filter.png'
import 'react-tooltip/dist/react-tooltip.css'

import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import { ManHelperText } from '@craft-design-system/core-components-react';

import { Tooltip as ReactTooltip } from 'react-tooltip'

import YourComponent from './newComponent';
import TabComponent_filters from './tabs_filter';

import { useFilterContext } from './FilterContext';
import { useDynamicContext } from './DynamicContext';
import { useResetContext } from './ResetContext';
import Truck_filters from './Truck_filters';


const Sidebar = ({props}) => {
  console.log('sidebar',props);
  const [category, setcategoryValue] = useState('Bus');
  const [selectedValues, setSelectedValues] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownData, setDropdownStates] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showText, setShowText] = useState(false);
  const [showTextData, setShowTextData] = useState(false);
  const {filterdata,updateFilterData} = useFilterContext();
  const {resetdata, updateresetdata,clearGraphData} = useResetContext();
  //console.log('filterdata',filterdata);
  const {dynamicdata, updatedynamicdata} = useDynamicContext();
  // let {fetchData} = useDropdownData();

  console.log('filterdata',filterdata); 
  const { dynamicFiltering, dropdownInfo } = useDynamicFiltering();
  // //console.log('dropdownNames',dropdowndata); 
  const handleQuery = useHandleQuery();

  
function handleHelpClick() {
    window.location.href = `mailto:support@example.com?subject=Need Help&body=Please describe your problem here.`;
}

  const handleSelectChange = (selectedOptions, columnName) => {
    setSelectedValues(prevValues => {
      const newValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
      return {
        ...prevValues,
        [columnName]: newValues,
        
      };
    });
    setIsInitialLoad(false);
  };
  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: 'red',  // Change this to your desired color
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'grey' : state.isFocused ? '#EAEDF3' : null,
      color: state.isSelected ? 'white' : 'black',

    }),
    control: (provided, state) => ({
      ...provided,
      borderRadius: '1px',
      borderWidth: '1px',
      borderColor: '#5B6F85',
      cursor: 'pointer',
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        // display: 'inline-block',
        // margin: '2px',
      };
    },
    valueContainer: (styles, { data }) => {
      return {
        ...styles,
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto',
      };
    },
  };


    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          Reset all filters
        </Popover.Body>
      </Popover>
    );

    const popover_filter = (
      <Popover id="popover-basic">
        <Popover.Body>
        Update filter options

        </Popover.Body>
      </Popover>
    );

  useEffect(() => {
    console.log('resetdata',dropdownData);
    setDropdownStates(dropdownData);
    setSelectedValues(null);
  }, [dropdownData]);

  useEffect(() => {
    console.log('dynamicdata updated in Sidebar:', dynamicdata);
  }, [dynamicdata]);

  const handleButtonClick = async () => {
    setIsLoading(true);
    setShowText(true);
    //console.log('selectedValues',selectedValues);
    //console.log('filterdata',filterdata);
    if (filterdata === null) {
      setShowTextData('Please select at least one filter');
      setIsLoading(false);
      setTimeout(() => setShowText(false), 4000);  // Hide text after 1 second
    } else {
      setShowTextData('Updating filters...');
      const newDropdownInfo = await(dynamicFiltering({ selected_value: filterdata }));
      console.log('dynamic',newDropdownInfo);
      updatedynamicdata(newDropdownInfo);
      //console.log('newDropdownInfo',dynamicdata);
    
      setIsLoading(false);
      setShowTextData('Filters Updated!!');
      setTimeout(() => setShowText(false), 4000);  // Hide text after 1 second
    }
  };

  const resetFilters = () => {
    console.log('restdata',resetdata)
    if (resetdata === 'Truck') {
      updateresetdata('Truck1');
    }
    else {
      updateresetdata('Bus1');

      
    }
  };

  const handleApplyDynamicFiltering = async () => {
    console.log("Apply Dynamic Filtering clicked from Sidebar");
    
    if (!filterdata) {
      console.log("No filter data available");
      setShowText(true);
      setShowTextData('Please select filters first!');
      setTimeout(() => setShowText(false), 4000);
      return;
    }
    
    // Check if there are any active filters
    const activeFiltersCount = Object.entries(filterdata || {}).filter(([key, value]) => {
      return (
        !['username', 'resetdata', 'button_clicked', 'startDate', 'endDate', 'lastUpdated', 'lastChangedFilter'].includes(key) && 
        value && 
        (Array.isArray(value) ? value.length > 0 : true)
      );
    }).length;
    
    if (activeFiltersCount === 0) {
      console.log("No active filters to apply dynamic filtering");
      setShowText(true);
      setShowTextData('Please select at least one filter!');
      setTimeout(() => setShowText(false), 4000);
      return;
    }
    
    try {
      setIsLoading(true);
      setShowText(true);
      setShowTextData('Applying dynamic filtering...');
      
      console.log("Applying dynamic filtering with filterdata:", filterdata);
      
      // Call the dynamicFiltering function
      const dynamicResult = await dynamicFiltering({ selected_value: filterdata });
      
      if (dynamicResult) {
        console.log("Dynamic filtering successful:", dynamicResult);
        console.log("Current dynamicdata before update:", dynamicdata);
        updatedynamicdata(dynamicResult);
        console.log("Dynamic data should be updated now");
        setShowTextData('Dynamic filtering applied!');
      } else {
        console.error("Dynamic filtering returned no results");
        setShowTextData('Dynamic filtering failed!');
      }
    } catch (error) {
      console.error("Error in dynamic filtering:", error);
      setShowTextData('Dynamic filtering error!');
    } finally {
      setIsLoading(false);
      setTimeout(() => setShowText(false), 4000);
    }
  };



  return (
    
    <div className='sidebar'>
      <div className="sidebar-title">
        <ManText  className="filter-title" variant={"heading-l"} as={"span"}>
          Filters
        </ManText>

        {/* Dynamic Filtering Button - First */}
        <button className='update_img' >
        <img src={filter} alt="filter image" onClick={handleApplyDynamicFiltering} className='filter_image'/>
        </button>

        {/* Reset Button - Second */}
        <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
        <button className='update_img' >
        <img src={reload} alt="button image" onClick={resetFilters} className='reload_image'/>
        </button>
        </OverlayTrigger>
        


        
        <YourComponent selected_value={filterdata} dynamicdata={dynamicdata} username={props} />

      </div>

      {showText && <div style={{color:'rgb(48,60,73)',fontFamily:'MAN EUROPE_Bold',display:'flex',justifyContent:'center'}}>
      <ManHelperText
        style={{fontSize: '14px'}}
        content={showTextData}
        variant="error"
        show={true}
        ></ManHelperText>

        </div>}


      <TabComponent_filters initial_tab={'Bus'} dynamic_filter={filterdata} dynamicdata={dynamicdata} username={props} />
    </div>
  );
};

export default Sidebar;
